export const fieldDescriptionWrapperSelectorName = 'jira-issue-field-icon-popup-wrapper';
